<div class="economics-totals-community-container" fxLayout="column" fxLayoutGap="15px"
     *appVar="hierarchyEntity|async as entity">

    <!-- top bar -->
    <app-filter-bar
            [showNullData]="showNullData"
            [config]="billingPeriodCfg"
            [billingPeriod]="billingPeriod"
            [useFilter]="true"
            [showGSEBtn]="false"
            [templateIsDownloading]="false"
            (billingPeriodEventEmitter)="onChangeBillingPeriod($event)">
        <!--            [response]="summary"-->
        <!--            (exportDataEventEmitter)="exportEconomicsToExcel()"-->
    </app-filter-bar>

    <!-- info section -->
    <ng-container *ngIf="entity && isViewable(entity); else unviewableEntity">
        <ng-container *ngIf="response; else loading">
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px" class="mb-20">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div class="txt-h-20-7">{{ 'Community economics and energy data'|i18n }}</div>
                    <app-icon *ngIf="communityNotConfigured" icon-color-w name="fas-exclamation-triangle"
                              [title]="'We are configuring the economic parameters of your community. You will soon be able to view your data.'|i18n">
                    </app-icon>
                    <app-icon icon-color-w name="fas-exclamation-triangle"
                              *ngIf="hasError(EconomicsErrorType.MISSING_ZONAL_PRICE, response.errors) && showError(EconomicsErrorType.MISSING_ZONAL_PRICE, response.errors)"
                              [title]="'Due to partial zonal price supply, we cannot show you complete economic data for this period. No action is required on your part.'|i18n">
                    </app-icon>
                    <!-- estimated data label -->
                    <div *ngIf="dataSourceInfo" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-h-12-4">
                        <app-icon icon-color-h [name]="dataSourceInfo.iconName"></app-icon>
                        <div>{{ dataSourceInfo.title|i18n }}</div>
                        <app-icon icon-color-h name="fas-info-circle" [title]="dataSourceInfo.iconTitle|i18n"></app-icon>
                    </div>
                    <app-icon icon-color-w name="fas-exclamation-triangle"
                              *ngIf="hasError(EconomicsErrorType.MISSING_DATA, response.errors) && showError(EconomicsErrorType.MISSING_DATA, response.errors)
                            && dataSourceInfo.mode !== ECMode.BASE"
                              [title]="'We did not receive some readings from the smart meters on this period. We estimated the missing data through statistical profiles.'|i18n">
                    </app-icon>
                </div>
                <div *ngIf="response.gse"  fxLayout="row" fxLayoutAlign="end center">
                    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start start">
                        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                            <span class="legend-dot accent-variant"></span>
                            <span class="txt-s-12-4">{{ 'Estimated value'|i18n }}</span>
                        </div>
                        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                            <span class="legend-dot accent"></span>
                            <span class="txt-s-12-4">{{ 'GSE data'|i18n }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <!-- end of info section -->

    <!-- start of tiles section -->
    <ng-container *ngIf="response">
        <div *ngIf="dataSourceInfo" fxLayout="column" fxLayoutGap="20px">
            <!-- top row -->
            <div fxLayout="row" fxLayoutAlign="space-between stretch" *ngIf="showEconomicsData">
                <div fxLayout="column" fxLayoutGap="20px" fxFlex class="tile">
                    <div class="txt-h-18-7">{{ 'Community plants injected energy withdrawal'|i18n }}</div>
                    <div fxLayout="row" fxLayoutGap="50px">
                        <div fxLayout="column">
                            <div fxLayout="row" fxLayoutGap="10px">
                                <app-icon icon-color-h name="fal-piggy-bank"></app-icon>
                                <div class="txt-h-12-4">{{ 'Injected energy'|i18n }}</div>
                                <app-icon icon-color-h name="fas-info-circle"
                                          [title]="'It is the electricity actually fed into the grid plus conventional loss coefficients, as provided for in Article 76 of ARERA\'s TIS, to take into account electricity losses on transmission and distribution grids and used for energy retirement purposes.'|i18n">
                                </app-icon>
                            </div>
                            <div class="txt-h-16-7">
                                {{ keepYourSecrets ? '-' : response.ec_plants_injected_energy|niceValue:'kWh' }}
                            </div>
                        </div>
                        <div fxLayout="column">
                            <div fxLayout="row" fxLayoutGap="10px">
                                <app-icon icon-color-h name="fal-piggy-bank"></app-icon>
                                <div class="txt-h-12-4">{{ 'Incentive'|i18n }}</div>
                            </div>
                            <div class="txt-h-16-7">{{ keepYourSecrets ? '-' : response.ec_plants_rei|niceValue:'€' }}</div>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <app-icon icon-color-h name="fal-solar-panel"></app-icon>
                        <div class="txt-h-12-4">{{ 'Share dedicated to redistribution:'|i18n }}</div>
                        <div class="txt-h-24-7">
                            {{ keepYourSecrets ? '-' : response.redistributable_ec_plants_rei|niceValue:'€' }}
                        </div>
                    </div>
                </div>
                <div fxFlex="1"></div>
                <div fxLayout="column" fxFlex class="tile">
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-30">
                        <div class="txt-h-18-7">{{ 'Total net incentive'|i18n }}</div>
                        <div class="txt-h-24-7">{{ keepYourSecrets ? '-' : (response.net_tip + response.net_c_acv)|niceValue:'€' : 2: (response.net_tip + response.net_c_acv) < 0 }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <app-icon icon-color-h name="fal-piggy-bank"></app-icon>
                        <div class="txt-h-12-4">{{ 'Incentive premium fee (TIP)'|i18n }}:</div>
                        <div class="txt-h-24-7">{{ keepYourSecrets ? '-' : response.net_tip|niceValue:'€' : 2: response.net_tip < 0 }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="mt-20">
                        <app-icon icon-color-h name="fal-piggy-bank"></app-icon>
                        <div class="txt-h-12-4"
                             [innerHTML]="'Contribution enhancement energy self-consumed electricity ({0}):'|i18n: CACV_STRING">:
                        </div>
                        <div class="txt-h-24-7">{{ keepYourSecrets ? '-' : response.net_c_acv|niceValue:'€': 2: response.net_c_acv < 0 }}</div>
                    </div>
                    <ng-container *appVar="response.capital_grant_plants_count as cg_plants">
                        <div *ngIf="cg_plants > 0" class="txt-acc-12-4 mt-20">
                            <app-icon name="fal-check-circle"></app-icon>
                            {{ 'You are using the capital grant for {0} {1}'|i18n:cg_plants:((cg_plants > 1 ? 'plants' : 'plant')|i18n) }}
                        </div>
                    </ng-container>
                </div>
                <div fxFlex="1"></div>
                <div fxLayout="column" fxLayoutGap="20px" fxFlex="20" class="tile">
                    <div class="txt-h-18-7">{{ 'Redistribution total'|i18n }}</div>
                    <div class="txt-h-24-7">
                        {{ keepYourSecrets ? '-' : (response.redistributable_cacv + response.redistributable_tip + response.redistributable_ec_plants_rei)|niceValue:'€' : 2: (response.redistributable_cacv + response.redistributable_tip + response.redistributable_ec_plants_rei) < 0 }}
                    </div>
                </div>
            </div>

            <!-- bottom row -->
            <div fxLayout="row" fxLayoutAlign="space-between start">

                <!-- left column -->
                <div fxLayout="column" fxLayoutGap="20px" fxFlex="25">
                    <!-- row 1 -->
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="tile">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <app-icon icon-color-h name="fal-solar-panel"></app-icon>
                            <div class="txt-h-18-7">{{ 'Produced energy__{eco}'|i18n }}</div>
                        </div>
                        <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                        <div *ngIf="!keepYourSecrets" class="txt-e-24-7">{{ response.produced_energy|niceValue:'kWh' }}</div>
                    </div>
                    <!-- row 2 -->
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="tile">
                        <div class="txt-s-16-7">{{ 'Avoided {0}'|i18n:'CO&#8322;' }}</div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                            <div *ngIf="!keepYourSecrets" class="txt-e-16-7">{{ response.saved_co2 / 1000000|niceValue:'t' }}</div>
                            <app-icon icon-color-h name="fas-info-circle" class="small-icon" [title]="co2Title"></app-icon>
                        </div>
                    </div>
                    <!-- row 3 -->
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="tile">
                        <div class="txt-s-16-7">{{ 'Saved natural gas'|i18n:'CO&#8322;' }}</div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                            <div *ngIf="!keepYourSecrets" class="txt-e-16-7">{{ response.saved_gas|niceValue:'Smc' }}</div>
                            <app-icon icon-color-h name="fas-info-circle" class="small-icon" [title]="gasTitle"></app-icon>
                        </div>
                    </div>
                </div>

                <!-- middle group -->
                <div fxLayout="row" fxLayoutGap="20px" fxFlex="43" class="dark-tile">
                    <div fxLayout="column" fxLayoutGap="20px" fxFlex="50">
                        <div fxLayout="column" fxLayoutGap="20px" class="tile">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                <app-icon icon-color-h name="fal-plug"></app-icon>
                                <div class="txt-h-16-7">{{ 'Absorbed energy'|i18n }}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                <app-icon icon-color-h [name]="dataSourceInfo.iconName"></app-icon>
                                <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                <div *ngIf="!keepYourSecrets" [ngClass]="response.gse ? 'txt-e-18-7' : 'txt-e-26-7'">
                                    {{ response.estimated_absorbed_energy|niceValue:'kWh' }}
                                </div>
                                <ng-container *ngIf="response.gse">
                                    <app-icon icon-color-h name="fal-check-circle" class="ml-10"></app-icon>
                                    <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                    <div *ngIf="!keepYourSecrets" class="txt-acc-24-7">{{ response.absorbed_energy|niceValue:'kWh' }}</div>
                                </ng-container>
                            </div>
                        </div>
                        <div fxLayout="column" fxLayoutGap="20px" class="tile">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                    <app-icon icon-color-h name="fal-paper-plane"></app-icon>
                                    <div class="txt-h-16-7">{{ 'Effective injected energy'|i18n }}</div>
                                </div>
                                <app-icon icon-color-h name="fas-info-circle"
                                          [title]="'Electricity actually fed in from feed-in points without the addition of conventional loss coefficients and used to determine shared energy.'|i18n">
                                </app-icon>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                <app-icon icon-color-h [name]="dataSourceInfo.iconName"></app-icon>
                                <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                <div *ngIf="!keepYourSecrets" [ngClass]="response.gse ? 'txt-e-18-7' : 'txt-e-26-7'">
                                    {{ response.estimated_effective_injected_energy|niceValue:'kWh' }}
                                </div>
                                <ng-container *ngIf="response.gse">
                                    <app-icon icon-color-h name="fal-check-circle" class="ml-10"></app-icon>
                                    <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                    <div *ngIf="!keepYourSecrets" class="txt-acc-24-7">
                                        {{ response.effective_injected_energy|niceValue:'kWh' }}
                                    </div>
                                </ng-container>
                            </div>
                            <div fxLayout="row" [fxLayoutAlign]="response.gse ? 'start start' : 'start center'" fxLayoutGap="10px"
                                 *ngIf="nonIncentivizedPlants">
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                    <app-icon icon-color-h name="fal-piggy-bank"></app-icon>
                                    <div *ngIf="!keepYourSecrets" class="txt-h-12-4">{{ 'of which coming from incentivized plants'|i18n }}:</div>
                                </div>
                                <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                <div fxLayout="column" fxLayoutGap="10px">
                                    <div *ngIf="!keepYourSecrets" [ngClass]="response.gse ? 'txt-e-18-7' : 'txt-e-26-7'">
                                        {{ response.estimated_incentive_effective_injected_energy|niceValue:'kWh' }}
                                    </div>
                                    <ng-container *ngIf="response.gse">
                                        <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                        <div *ngIf="!keepYourSecrets"
                                             class="txt-acc-24-7">{{ response.incentive_effective_injected_energy|niceValue:'kWh' }}
                                        </div>
                                    </ng-container>
                                </div>
                                <app-icon icon-color-h name="fas-info-circle"
                                          [title]="'Effective injected energy coming from plants incentivized by the regulations'|i18n">
                                </app-icon>
                            </div>
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="20px" fxFlex class="tile">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <app-icon icon-color-h name="fal-plug"></app-icon>
                            <div class="txt-h-16-7">{{ 'Shared energy'|i18n }}</div>
                        </div>
                        <div fxLayout="column" fxLayoutGap="10px">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                <app-icon icon-color-h [name]="dataSourceInfo.iconName"></app-icon>
                                <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                <div *ngIf="!keepYourSecrets" [ngClass]="response.gse ? 'txt-e-18-7' : 'txt-e-26-7'">
                                    {{ response.estimated_shared_energy|niceValue:'kWh' }}
                                </div>
                                <ng-container *ngIf="response.gse">
                                    <app-icon icon-color-h name="fal-check-circle" class="ml-10"></app-icon>
                                    <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                    <div *ngIf="!keepYourSecrets" class="txt-acc-24-7">{{ response.shared_energy|niceValue:'kWh' }}</div>
                                </ng-container>
                                <app-icon icon-color-h name="fas-info-circle"
                                          [title]="'Energy virtually self-consumed by community members through the distribution network'|i18n">
                                </app-icon>
                            </div>
                            <div fxLayout="row" [fxLayoutAlign]="response.gse ? 'start start' : 'start center'" fxLayoutGap="10px"
                                 *ngIf="nonIncentivizedPlants">
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                    <app-icon icon-color-h name="fal-piggy-bank"></app-icon>
                                    <div *ngIf="!keepYourSecrets" class="txt-h-12-4">{{ 'of which incentive'|i18n }}:</div>
                                </div>
                                <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                <div fxLayout="column" fxLayoutGap="10px">
                                    <div *ngIf="!keepYourSecrets" [ngClass]="response.gse ? 'txt-e-18-7' : 'txt-e-26-7'">
                                        {{ response.estimated_incentive_shared_energy|niceValue:'kWh' }}
                                    </div>
                                    <ng-container *ngIf="response.gse">
                                        <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                        <div *ngIf="!keepYourSecrets"
                                             class="txt-acc-24-7">{{ response.incentive_shared_energy|niceValue:'kWh' }}
                                        </div>
                                    </ng-container>
                                </div>
                                <app-icon icon-color-h name="fas-info-circle"
                                          [title]="'Portion of shared energy for which plants get TIP.'|i18n">
                                </app-icon>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <div class="txt-h-16-7">{{ 'Share performance'|i18n }}</div>
                            <app-icon icon-color-h name="fas-info-circle"
                                      [title]="'How much of the energy input alone was shared by the community, becoming shared energy'|i18n">
                            </app-icon>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <app-icon icon-color-h [name]="dataSourceInfo.iconName"></app-icon>
                            <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                            <div *ngIf="!keepYourSecrets" [ngClass]="response.gse ? 'txt-e-18-7' : 'txt-e-26-7'">
                                {{ (response.estimated_share_performance * 100)|niceValue:'%' }}
                            </div>
                            <ng-container *ngIf="response.gse">
                                <app-icon icon-color-h name="fal-check-circle" class="ml-10"></app-icon>
                                <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                <div *ngIf="!keepYourSecrets" class="txt-acc-24-7">{{ response.share_performance|niceValue:'kWh' }}</div>
                            </ng-container>
                        </div>
                        <div fxLayout="row" [fxLayoutAlign]="response.gse ? 'start start' : 'start center'" fxLayoutGap="10px"
                        *ngIf="nonIncentivizedPlants">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                <app-icon icon-color-h name="fal-piggy-bank"></app-icon>
                                <div *ngIf="!keepYourSecrets" class="txt-h-12-4">{{ 'of which incentive'|i18n }}:</div>
                            </div>
                            <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                            <div fxLayout="column" fxLayoutGap="10px">
                                <div *ngIf="!keepYourSecrets" [ngClass]="response.gse ? 'txt-e-18-7' : 'txt-e-26-7'">
                                    {{ response.estimated_incentive_share_performance*100|niceValue:'%' }}
                                </div>
                                <ng-container *ngIf="response.gse">
                                    <div *ngIf="keepYourSecrets" class="txt-h-24-7">-</div>
                                    <div *ngIf="!keepYourSecrets"
                                         class="txt-acc-24-7">{{ response.incentive_share_performance*100|niceValue:'%' }}
                                    </div>
                                </ng-container>
                            </div>
                            <app-icon icon-color-h name="fas-info-circle"
                                      [title]="'Shared energy for which plants having as incentive mode \'Old regulations\' or \'New regulations\' are getting TIP'|i18n">
                            </app-icon>
                        </div>
                    </div>
                </div>

                <!-- right tile -->
                <div fxLayout="column" fxLayoutGap="20px" fxFlex="30" class="tile">
                    <div class="txt-h-14-7">{{ 'Parameters'|i18n }}</div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <div class="txt-s-12-7">{{ 'TRASe BT' }}:</div>
                            <div class="txt-s-12-4">{{ (keepYourSecrets || !response.params.trase_bt) ? '-' : response.params.trase_bt|niceValue: '€/MWh':2 }}</div>
                            <app-icon icon-color-h name="fas-info-circle"
                                      [title]="'TRASe BT: transmission tariff on low voltage.'|i18n">
                            </app-icon>
                        </div>
                        <ng-container *ngIf="entity.sub_type === EntitySubType.COLLECTIVE_SELF_CONSUMPTION_GROUP">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                <span class="txt-s-12-7">{{ 'BTAU' }}:</span>
                                <span class="txt-s-12-4">{{ (keepYourSecrets || !response.params.btau) ? '-' : response.params.btau|niceValue: '€/MWh':2 }}</span>
                                <app-icon icon-color-h name="fas-info-circle"
                                          [title]="'BTAU: the maximum among low-voltage distribution variable components.'|i18n">
                                </app-icon>
                            </div>

                            <div *ngIf="!!response.params.nl_bt"
                                 fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                <span class="txt-s-12-7" [innerHTML]="CPR_BT_STRING + ':'"></span>
                                <span class="txt-s-12-4">{{ keepYourSecrets ? '-' : (response.params.nl_bt * 100)|niceValue: '%':2 }}</span>
                                <app-icon icon-color-h name="fas-info-circle"
                                          [title]="'Low voltage network loss coefficient.'|i18n">
                                </app-icon>
                            </div>
                            <div *ngIf="!!response.params.nl_mt"
                                 fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                <span class="txt-s-12-7" [innerHTML]="CPR_MT_STRING + ':'"></span>
                                <span class="txt-s-12-4">{{ keepYourSecrets ? '-' : (response.params.nl_mt * 100)|niceValue: '%':2 }}</span>
                                <app-icon icon-color-h name="fas-info-circle"
                                          [title]="'Medium voltage network loss coefficient.'|i18n">
                                </app-icon>
                            </div>
                        </ng-container>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button app-ghost-button (click)="onClickMarketIndicators()"
                                [disabled]="showNullData">
                            {{ 'Energy market indicators'|i18n }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- end of tiles section -->

        <mat-expansion-panel *ngIf="!keepYourSecrets">
            <mat-expansion-panel-header>
                <mat-panel-description fxLayoutAlign="start center" fxLayoutGap="10px">
                    <app-icon icon-color-s name="fal-bolt"></app-icon>
                    <span>{{ 'Community sharing'|i18n }}</span>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <ng-container
                    *ngTemplateOutlet="sharedEnergyChart">
            </ng-container>
            <ng-container
                    *ngTemplateOutlet="energyRatioChart">
            </ng-container>
        </mat-expansion-panel>
    </ng-container>
</div>


<!-- loading spinner -->
<ng-template #loading>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
        <mat-spinner app-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{ 'Loading'|i18n }}...</span>
    </div>
</ng-template>

<!-- unviewable entity warning -->
<ng-template #unviewableEntity>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{ 'Insufficient permissions to view this resource'|i18n }}
    </div>
</ng-template>

<!-- ec waiting for approval info -->
<ng-template #ecWaitingForApproval>
    <div fxLayout="column" class="p-30" fxLayoutAlign="center center">
        <div class="txt-h-24-7">{{ 'Community waiting for activation'|i18n }}</div>
        <app-icon icon-color-h name="fal-clock" fxFlex="60" class="clock-icon mt-30 mb-30"></app-icon>
        <ng-container *ngIf="inactiveEc">
            <div class="txt-s-16-4">{{ 'This community has no activation date yet.'|i18n }}</div>
            <div class="txt-s-16-4">{{ 'As soon as the community is activated, you will see economic and energy data here.'|i18n }}</div>
        </ng-container>
        <ng-container *ngIf="!inactiveEc">
            <div class="txt-s-16-4">{{ 'This community will be activated by {0}.'|i18n:(billingPeriodCfg.pastDate|i18nDate) }}</div>
            <div class="txt-s-16-4">{{ 'Economic data will be available from that day.'|i18n }}</div>
        </ng-container>
        <div mat-dialog-actions class="dialog-actions mt-30">
            <button app-primary-button [mat-dialog-close]="true">
                {{ 'Ok'|i18n }}
            </button>
        </div>
    </div>
</ng-template>



<ng-template #sharedEnergyChart let-data="data">
    <div *ngIf="energiesChartOptions" fxLayout="column" class="mt-16">
        <div fxLayout="column" fxLayoutAlign="start stretch">
            <div fxLayout="row" fxLayoutAlign="start" class="quantity-name" fxLayoutGap="20px">
                <span class="text-primary"> {{ 'Shared energy'|i18n }} </span>
                <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="15px">
                    <mat-checkbox app-checkbox
                                  [checked]="sharedEnergyEstimatedData"
                                  (change)="updateEnergyEstimated($event.checked)"
                    >
                        <span class="txt-h-12-4"> {{'Estimated data'|i18n}}</span>
                    </mat-checkbox>
                    <mat-checkbox app-checkbox
                                  [checked]="sharedEnergyConsolidatedData"
                                  [disabled]="!consolidationsAvailable(response)"
                                  (change)="updateEnergyConsolidated($event.checked)">
                        <span class="txt-h-12-4"> {{'Consolidated data'|i18n}} </span>
                    </mat-checkbox>
                </div>
            </div>
            <div *ngIf="!energiesChartOptions.series" fxLayout="row" fxLayoutAlign="center">
                <app-icon icon-color-s name="fal-exclamation-circle"></app-icon>&nbsp;
                {{ 'No data'|i18n }}
            </div>
            <ng-container *ngIf="energiesChartOptions.series">
                <div class="shared-energy">
                    <apx-chart
                            [series]="energiesChartOptions.series"
                            [chart]="energiesChartOptions.chart"
                            [stroke]="energiesChartOptions.stroke"
                            [dataLabels]="energiesChartOptions.dataLabels"
                            [plotOptions]="energiesChartOptions.plotOptions"
                            [xaxis]="energiesChartOptions.xaxis"
                            [colors]="energiesChartOptions.colors"
                            [fill]="energiesChartOptions.fill"
                            [yaxis]="energiesChartOptions.yaxis"
                            [legend]="energiesChartOptions.legend"></apx-chart>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>



<ng-template #energyRatioChart let-data="data">
    <div *ngIf="energyRatioChartOptions" fxLayout="column" class="mt-16">
        <div fxLayout="column" fxLayoutAlign="start stretch">
            <div fxLayout="row" fxLayoutAlign="start" class="quantity-name" fxLayoutGap="20px">
                <span class="text-primary"> {{ 'Shared energy ratio'|i18n }} </span>
                <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="15px">
                    <mat-checkbox app-checkbox
                                  [checked]="energyRatioEstimatedData"
                                  (change)="updateEnergyRatioEstimated($event.checked)"
                    >
                        <span class="txt-h-12-4"> {{'Estimated data'|i18n}}</span>
                    </mat-checkbox>
                    <mat-checkbox app-checkbox
                                  [checked]="energyRatioConsolidatedData"
                                  [disabled]="!consolidationsAvailable(response)"
                                  (change)="updateEnergyRatioConsolidated($event.checked)">
                        <span class="txt-h-12-4"> {{'Consolidated data'|i18n}} </span>
                    </mat-checkbox>
                </div>
            </div>
            <div *ngIf="!energyRatioChartOptions.series" fxLayout="row" fxLayoutAlign="center">
                <app-icon icon-color-s name="fal-exclamation-circle"></app-icon>&nbsp;
                {{ 'No data'|i18n }}
            </div>
            <ng-container *ngIf="energyRatioChartOptions.series">
                <div class="shared-energy">
                    <apx-chart
                            [series]="energyRatioChartOptions.series"
                            [chart]="energyRatioChartOptions.chart"
                            [stroke]="energyRatioChartOptions.stroke"
                            [dataLabels]="energyRatioChartOptions.dataLabels"
                            [plotOptions]="energyRatioChartOptions.plotOptions"
                            [xaxis]="energyRatioChartOptions.xaxis"
                            [colors]="energyRatioChartOptions.colors"
                            [fill]="energyRatioChartOptions.fill"
                            [yaxis]="energyRatioChartOptions.yaxis"
                            [legend]="energyRatioChartOptions.legend"></apx-chart>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
